<style scoped lang="scss"></style>

<template>
  <div>
    <div class="uk-form" v-if="application">
      <fieldset data-uk-margin>
        <div>
          <legend>{{ __(`tenant.tpa_title`) }}</legend>

          <p
            v-html="
              __(`tenant.tpa_content`, {
                agency: env.AGENCY_SHORT_NAME,
                program: application.program.program_abbreviation,
              })
            "
          ></p>

          <p v-html="__(`tenant.tpa_content_section_1_header`)"></p>
          <ul>
            <li v-html="__(`tenant.tpa_content_section_1_list_1`)"></li>
            <li v-html="__(`tenant.tpa_content_section_1_list_2`)"></li>
            <li v-html="__(`tenant.tpa_content_section_1_list_3`)"></li>
          </ul>

          <p v-html="__(`tenant.tpa_content_section_2_header`)"></p>
          <ul>
            <li v-html="__(`tenant.tpa_content_section_2_list_1`)"></li>
            <li v-html="__(`tenant.tpa_content_section_2_list_2`)"></li>
            <li v-html="__(`tenant.tpa_content_section_2_list_3`)"></li>
            <li v-html="__(`tenant.tpa_content_section_2_list_4`)"></li>
            <li v-html="__(`tenant.tpa_content_section_2_list_5`)"></li>
            <li v-html="__(`tenant.tpa_content_section_2_list_6`)"></li>
            <li v-html="__(`tenant.tpa_content_section_2_list_7`)"></li>
            <li v-html="__(`tenant.tpa_content_section_2_list_8`)"></li>
          </ul>
          <p v-html="__(`tenant.tpa_content_section_2_foot`)"></p>

          <p v-html="__(`tenant.tpa_content_section_3_header`)"></p>
          <ul>
            <li v-html="__(`tenant.tpa_content_section_3_list_1`)"></li>
            <li v-html="__(`tenant.tpa_content_section_3_list_2`)"></li>
          </ul>

          <p v-html="__(`tenant.tpa_content_section_4_header`)"></p>
          <ul>
            <li v-html="__(`tenant.tpa_content_section_4_list_1`)"></li>
            <li v-html="__(`tenant.tpa_content_section_4_list_2`)"></li>
            <li v-html="__(`tenant.tpa_content_section_4_list_3`)"></li>
            <li v-html="__(`tenant.tpa_content_section_4_list_4`)"></li>
          </ul>

          <p v-html="__(`tenant.tpa_content_section_5_content`)"></p>

          <p v-html="__(`tenant.tpa_content_section_6_header`)"></p>
          <ul>
            <li v-html="__(`tenant.tpa_content_section_6_list_1`)"></li>
            <li v-html="__(`tenant.tpa_content_section_6_list_2`)"></li>
            <li v-html="__(`tenant.tpa_content_section_6_list_3`)"></li>
          </ul>

          <p v-html="__(`tenant.tpa_content_section_7_header`)"></p>
          <ul>
            <li v-html="__(`tenant.tpa_content_section_7_list_1`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_2`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_3`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_4`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_5`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_6`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_7`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_8`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_9`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_10`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_11`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_12`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_13`)"></li>
            <li v-html="__(`tenant.tpa_content_section_7_list_14`)"></li>
          </ul>

          <p v-html="__(`tenant.tpa_content_section_8_header`)"></p>

          <validated-section :errors="errors" field="agreement_selection">
            <div class="uk-width-1-1">
              <label class="checkbox-container">
                <input
                  type="radio"
                  v-model="agreement_selection"
                  :value="1"
                  id="agreement-agree"
                  name="agreement"
                  :disabled="hasMadeAgreement"
                />
                <span v-html="__(`tenant.tpa_content_section_8_agree`)"></span>
              </label>
            </div>
            <div class="uk-width-1-1">
              <label class="checkbox-container">
                <input
                  type="radio"
                  v-model="agreement_selection"
                  :value="0"
                  id="agreement-disagree"
                  name="agreement"
                  :disabled="hasMadeAgreement"
                />
                <span
                  v-html="__(`tenant.tpa_content_section_8_disagree`)"
                ></span>
              </label>
            </div>
          </validated-section>

          <p class="uk-text-danger" id="agreement-error"></p>
          <p v-html="__(`tenant.tpa_content_section_9_header`)"></p>
          <ul>
            <li v-html="__(`tenant.tpa_content_section_9_list_1`)"></li>
            <li v-html="__(`tenant.tpa_content_section_9_list_2`)"></li>
            <li v-html="__(`tenant.tpa_content_section_9_list_3`)"></li>
          </ul>

          <p><i>*This is for all household members</i></p>
        </div>
      </fieldset>

      <div class="uk-margin-large-bottom">
        <fieldset>
          <div class="uk-container uk-margin-top">
            <div class="uk-grid" v-if="application.household">
              <div
                class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2"
                v-for="member in application.household.members"
              >
                <div v-if="signatureEnabled(member)">
                  <validated-section
                    :errors="errors"
                    :field="'signature_' + member.id"
                  >
                    <signature-box
                      @updated="onSignatureUpdated"
                      :user-key="member.id"
                      :is-signed="
                        signatureData[member.id] &&
                        signatureData[member.id]
                          .third_party_authorization_signed_at !== null
                      "
                      :completed="
                        signatureData[member.id] &&
                        signatureData[member.id].completed
                      "
                      :name="member.first_name + ' ' + member.last_name"
                      :color="programSettings['primary-program-color']"
                    ></signature-box>
                  </validated-section>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
import ValidatedSection from "../../../../../components/Common/ValidatedSection";

export default {
  name: "ThirdPartyAuthorization",
  components: { ValidatedSection, SignatureBox },
  data() {
    return {
      agreement_selection: null,
      hasMadeAgreement: false,
      selection_pass_error: "",
      signatureData: {},
      errors: {},
    };
  },
  computed: {
    ...mapState("Application", {
      application: (state) => state.application,
    }),
    ...mapState("App", {
      env: (state) => state.env,
    }),
    ...mapGetters("Application", ["programSettings"]),
  },
  watch: {
    application(newValue) {
      if (newValue.household) {
        this.initData();
      }
    },
  },
  mounted() {
    if (this.application) this.initData();
  },
  methods: {
    initData() {
      this.agreement_selection = this.application.information_share_consent;
      if (this.agreement_selection !== null) {
        this.hasMadeAgreement = true;
      }

      _.each(this.application.household.members, (member) => {
        if (this.signatureEnabled(member)) {
          const signatureFiltered = member.signatures.find(
            (item) => item.key === `app-privacy-policy`
          );
          if (signatureFiltered) {
            this.$set(this.signatureData, member.id, {
              third_party_authorization_signed_at: signatureFiltered.created_at,
              completed: true,
            });
          }
        }
      });
    },

    signatureEnabled(member) {
      let res = false
      if (member.age >= 18 && (member.household_member_key === 1 || this.application.program.settings['require-memeber-signature']))
        res = true
      return res
    },

    onSignatureUpdated($event) {
      if (!this.signatureData[$event.key]) {
        this.$set(this.signatureData, $event.key, {});
      }
      this.$set(
        this.signatureData[$event.key],
        "third_party_authorization_signed_at",
        $event.isSigned ? moment().format("YYYY-MM-DD HH:mm") : null
      );
    },
    async validateStep() {
      this.errors = {};

      if (this.agreement_selection === null) {
        this.errors["agreement_selection"] = {
          errors: ["You must select one of the options above."],
        };
      }
      // Local Validation
      for (var i in this.application.household.members) {
        let member = this.application.household.members[i];
        if (this.signatureEnabled(member)) {
          if (!this.signatureData[member.id]) {
            this.errors["signature_" + member.id] = {
              errors: [
                member.first_name +
                  " " +
                  member.last_name +
                  " must sign this form as their name appears above.",
              ],
            };
          } else if (
            this.signatureData[member.id] &&
            this.signatureData[member.id].third_party_authorization_signed_at ==
              null
          ) {
            this.errors["signature_" + member.id] = {
              errors: [
                member.first_name +
                  " " +
                  member.last_name +
                  " must sign this form as their name appears above.",
              ],
            };
          }
        }
      }

      let errorCount = _.size(this.errors);

      if (errorCount > 0) return false;

      // Server Side Validation
      try {
        let response = await this.save();
        return true;
      } catch (err) {
        console.error(err);
      }
    },
    unitLedgerEntryVendors() {},
    async save() {
      let data = {
        signatures: this.signatureData,
        agreement: this.agreement_selection,
      };
      let r = axios.put(
        `/api/hope/applications/${this.application.id}/step-7`,
        data
      );

      window.setTimeout(async () => {
        await this.$store.dispatch("Application/fetch", this.application.id);
      }, 500);
    },
  },
};
</script>
